module.exports = __webpack_public_path__ + "1b4cb8d11ccd557e3259d9467a1421cd.png";